<template>
  <div class="candidate opportunities list ma-3" style="height: 100%;">
    <v-progress-linear
      indeterminate
      v-show="!cache && loading"
      :color="themes.candidate.light.loading"
      class="ma-0"
      height="5"
    />

    <template v-if="opportunities">
      <v-data-iterator
        :items="opportunities"
        :pagination.sync="pagination"
        content-tag="v-layout"
        column
        hide-actions
      >
        <div slot="item" slot-scope="{ item: opportunity }">
          <slot name="item" v-bind="{ opportunity, loading }">
            <v-flex class="mb-2">
              <OpportunityCard
                v-if="cache || !loading"
                :opportunity="opportunity"
                @input:apply="$emit('apply', opportunity)"
              />
            </v-flex>
          </slot>
        </div>

        <slot name="no-data" slot="no-data" class="mx-3">
          <v-card class="text-xs-center">
            <v-card-text>
              <v-alert outline :color="themes.candidate.light.primary" type="info" :value="true">
                <div>
                  <div class="title text-xs-left">No results</div>
                  <div class="subheading text-xs-left">
                    To view more opportunities, try moving around the map or zooming out
                  </div>
                </div>
              </v-alert>
            </v-card-text>
          </v-card>
        </slot>
      </v-data-iterator>

      <div v-if="showMoreButton" class="text-xs-center pt-5 pb-2">
        <v-btn @click="pagination.rowsPerPage += 10" color="success" round>
          Load more
        </v-btn>
      </div>
    </template>
  </div>
</template>

<script>
// Components
import OpportunityCard from '@/components/candidate/opportunities/OpportunityCard'

// Helpers
import _ from 'lodash'
import { mapState } from 'vuex'

// Mixins
import { CachedArray } from '@/mixins/CachedArray.js'

export default {
  mixins: [CachedArray],

  components: { OpportunityCard },

  props: { cache: { type: Boolean, default: false } },

  data() {
    return {
      pagination: {
        rowsPerPage: 5,
      },
    }
  },

  computed: {
    ...mapState('candidate/opportunityLocations', {
      loading: 'loading',
      opportunityLocations: 'all',
    }),

    locations() {
      let locations = this.cache ? this.cachedArray : this.opportunityLocations
      locations = JSON.parse(JSON.stringify(locations))

      return locations
        .filter(l => this.opportunityLocations.some(store => store.id === l.id))
        .sort((l1, l2) => {
          const i1 = this.opportunityLocations.findIndex(store => store.id === l1.id)
          const i2 = this.opportunityLocations.findIndex(store => store.id === l2.id)
          return i1 - i2
        })
    },

    opportunities() {
      if (!_.get(this, 'locations[0]')) return []

      return _.uniq(this.locations.map(l => l.opportunity), 'id')
    },

    total() {
      if (!_.get(this, 'locations[0]')) return 0
      return this.locations.length
    },

    showMoreButton() {
      return this.total > this.pagination.rowsPerPage
    },
  },

  watch: {
    opportunityLocations: function(newLocations) {
      if (this.cache) this.pushToCachedArray(newLocations)
    },
  },

  methods: {},
}
</script>
